<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="service-details-sidebar" position="left" lockedOpen="gt-md">
        <service-details-sidebar></service-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <mat-tab-group fxLayout="column" fxFlex>
                    <mat-tab label="{{'Basic data'|translate}}">
                        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                            <div class="h2 mb-24">{{'Service data'|translate}}</div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                    <mat-label>{{'Name'|translate}}</mat-label>
                                    <input matInput formControlName="name" required>
                                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                    <mat-error>{{'Name is required!'|translate}}</mat-error>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="80">
                                    <mat-label>{{'Category'|translate}}</mat-label>
                                    <mat-select formControlName="category">
                                        <mat-option [value]="category.id" *ngFor="let category of categories">
                                            {{category.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                                </mat-form-field>
                                <div fxFlex="20">
                                    <a mat-raised-button color="primary"
                                       (click)="addCategory()">{{'Add category'|translate}}</a>
                                </div>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100">
                                    <mat-label>{{'Type'|translate}}</mat-label>
                                    <mat-select formControlName="type">
                                        <mat-option [value]="type.id" *ngFor="let type of serviceTypes">
                                            {{type.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                    <mat-label>{{'Required time'|translate}}</mat-label>
                                    <input matInput formControlName="requiredTime">
                                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                    <mat-label>{{'Required credits'|translate}}</mat-label>
                                    <input matInput formControlName="requiredCredits" type="number">
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-checkbox formControlName="groupTraining" fxFlex="100">
                                    <mat-label>{{'Group training'|translate}}</mat-label>
                                </mat-checkbox>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="33" class="pr-4">
                                    <mat-label>{{'Price gross'|translate}}</mat-label>
                                    <input matInput formControlName="priceGross">
                                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                </mat-form-field>
                                <mat-form-field appearance="outline" fxFlex="33">
                                    <mat-label>{{'Vat rate'|translate}}</mat-label>
                                    <mat-select formControlName="vatRate">
                                        <mat-option [value]="vatRate.id" *ngFor="let vatRate of vatRates">
                                            {{vatRate.vatName}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100">
                                    <mat-label>{{'Description'|translate}}</mat-label>
                                    <textarea matInput formControlName="description"></textarea>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100">
                                    <mat-label>{{'Private description'|translate}}</mat-label>
                                    <textarea matInput formControlName="privateDescription"></textarea>
                                </mat-form-field>
                            </div>

                            <!--                    <div class="h4 mb-24">{{'Images'|translate}}</div>-->
                            <!--                    <input type="file" multiple (change)="onImagesChange($event)"/>-->
                            <!--                    <br/><br/>-->
                            <div class="h4 mb-24">{{'Documents'|translate}}</div>
                            <input type="file" multiple (change)="onDocumentsChange($event)"/>

                            <br/><br/>

                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <ul style="list-style-type: none;">
                                    <li *ngFor="let resource of resources">
                                        <mat-checkbox class="example-margin" [checked]="checkedResources.includes(resource.id)" (change)="onChange($event)" [value]="resource">
                                            {{resource.name}}</mat-checkbox>
                                    </li>
                                </ul>
                            </div>

                            <br/><br/>

                            <div class="h4 mb-24">{{'Resources'|translate}}</div>

                            <div formArrayName="resourceGroups"
                                 *ngFor="let resourceGroup of resourceGroups().controls; index as i">
                                <div [formGroupName]="i">
                                    <div formArrayName="resources">
                                        <div *ngFor="let resource of resourceGroupResources(i).controls; index as j">
                                            <div [formGroupName]="j" fxLayout="row" fxLayoutAlign="start center"
                                                 fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="20">
                                                    <mat-select formControlName="id">
                                                        <mat-option [value]="resource.id"
                                                                    *ngFor="let resource of resources">
                                                            {{resource.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <button (click)="removeResource(i,j)" mat-raised-button
                                                    color="warn">{{'Remove'|translate}}</button>

                                        </div>
                                    </div>
                                    <button (click)="removeResourceGroup(i)" mat-raised-button
                                            color="warn">{{'Remove'|translate}}</button>
                                    <button type="button" (click)="addResource(i)" mat-raised-button
                                            color="primary">{{'Add resource'|translate}}</button>
                                </div>
                            </div>
                            <button type="button" (click)="addResourceGroup()" mat-raised-button
                                    color="primary">{{'Add resources group'|translate}}</button>


                            <div fxLayout="row" fxLayoutAlign="end center" fxFlex="1 0 auto">
                                <div fxLayout="row" fxLayoutAlign="end center" class="pt-24">
                                    <button mat-raised-button type="submit" color="accent" *ngIf="!saving">
                                        <mat-icon>save</mat-icon>
                                        {{'Save'|translate}}
                                    </button>
                                    <button mat-raised-button color="accent" *ngIf="saving" disabled>
                                        <mat-icon *ngIf="saving">autorenew</mat-icon>
                                        {{'Saving'|translate}}
                                    </button>&nbsp;&nbsp;
                                </div>
                            </div>
                        </form>
                    </mat-tab>
                    <mat-tab label="{{'Images'|translate}}" *ngIf="gallery">
                        <div class="order-details tab-content p-24" fusePerfectScrollbar>

                            <div class="content-card" style="overflow-y: scroll;">
                                <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                                    <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column"
                                         fxLayoutAlign="start"
                                         fxFlex="1 0 auto">

                                        <table>
                                            <tr>
                                                <td>
                                                    <div class="center">
                                                        <div class="container" appDnd
                                                             (fileDropped)="onFileDropped($event)">
                                                            <input type="file" #fileDropRef id="fileDropRef" multiple
                                                                   (change)="fileBrowseHandler($event.target.files)"/>
                                                            <mat-icon class="nav-link-icon">cloud_upload</mat-icon>
                                                            <h3>{{'Drag and drop file here'|translate}}</h3>
                                                            <h3>{{'or'|translate}}</h3>
                                                            <label for="fileDropRef">{{'Browse for file'|translate}}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <div fxLayout="row" class="files-list">
                                                        <div class="single-file"
                                                             *ngFor="let file of files; let i = index">
                                                            <!--        <img src="assets/img/dnd/ic-file.svg" width="45px" alt="file">-->
                                                            <div class="info">
                                                                <h4 class="name">
                                                                    {{ file?.name }}
                                                                </h4>
                                                                <p class="size">
                                                                    {{ formatBytes(file?.size) }}
                                                                </p>
                                                                <app-progress
                                                                        [progress]="file?.progress"></app-progress>
                                                            </div>
                                                            <!--        <img src="assets/img/dnd/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">-->
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="cards" fxLayout="row wrap">
                                                        <div class="card" *ngFor="let image of this.gallery.items"
                                                             fxFlex="20">
                                                            <div class="card-preview" fxFlex="100">
                                                                <div class="fuse-card" fxFlex="100"
                                                                     (click)="showGalleryItemDialog(image)">
                                                                    <img src="data:image/png;base64,{{image.image}}"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>
